import React from "react";
import {
  ManageCompanyLayout,
  ManageCensusLayout,
  AccountBalanceComponent,
} from "../../../components";

const buttons = [];

function EmployeeAccountBalanceContainer(props) {
  return (
    <>
      <ManageCensusLayout buttons={buttons}>
        <div className="w-100">
          <AccountBalanceComponent />
        </div>
      </ManageCensusLayout>
    </>
  );
}

export default EmployeeAccountBalanceContainer;
